/**
 * Layout shared by the contouring tool trays — the strip of controls
 * that appears under the toolbar for the active tool.
 *
 * The trays sit side by side in the same strip, so their row metrics are
 * defined here once: a tray that spaced its controls differently would
 * make the toolbar jump as the user switches tools.
 */
export const toolTrayRowSx = {
    display: 'flex',
    alignItems: 'center',
    gap: 1.5,
    mx: -0.5,
} as const;
